module.exports = {
  "azimuth": "center",
  "border-collapse": "separate",
  "border-spacing": "0",
  "caption-side": "top",
  "caret-color": "auto",
  "color": "initial",
  "cursor": "auto",
  "empty-cells": "show",
  "font-family": "initial",
  "font-feature-settings": "normal",
  "font-kerning": "auto",
  "font-language-override": "normal",
  "font-size": "medium",
  "font-size-adjust": "none",
  "font-stretch": "normal",
  "font-style": "normal",
  "font-synthesis": "weight style",
  "font-variant": "normal",
  "font-variant-alternates": "normal",
  "font-variant-caps": "normal",
  "font-variant-east-asian": "normal",
  "font-variant-ligatures": "normal",
  "font-variant-numeric": "normal",
  "font-variant-position": "normal",
  "font-weight": "normal",
  "hyphens": "manual",
  "image-orientation": "0deg",
  "image-rendering": "auto",
  "image-resolution": "1dppx",
  "letter-spacing": "normal",
  "line-height": "normal",
  "list-style-image": "none",
  "list-style-position": "outside",
  "list-style-type": "disc",
  "object-position": "50% 50%",
  "orphans": "2",
  "overflow-wrap": "normal",
  "pointer-events": "auto",
  "quotes": "initial",
  "ruby-align": "space-around",
  "ruby-merge": "separate",
  "ruby-position": "over",
  "tab-size": "8",
  "text-align": "initial",
  "text-align-last": "auto",
  "text-combine-upright": "none",
  "text-indent": "0",
  "text-justify": "auto",
  "text-orientation": "mixed",
  "text-rendering": "auto",
  "text-shadow": "none",
  "text-transform": "none",
  "text-underline-position": "auto",
  "visibility": "visible",
  "white-space": "normal",
  "widows": "2",
  "word-break": "normal",
  "word-spacing": "normal",
  "word-wrap": "normal",
  "writing-mode": "horizontal-tb",
  "-webkit-appearance": "none",
  "-moz-appearance": "none",
  "-ms-appearance": "none",
  "appearance": "none"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-initials/inherited.js
// module id = 1
// module chunks = 0